import {
  SET_CATALOGS,
  SET_CATALOG_LOADING,
  SET_CATALOG_ERROR,
  CLEAR_CATALOGS,
} from 'redux/constants/catalogs';

export const initialState = {
  isLoading: false,
  error: null,
  catalogData: {},
};

function catalogsReducer(state = initialState, action) {
  const { payload = {}, type } = action;

  switch (type) {
    default:
      return state;

    case SET_CATALOGS:
      return {
        ...state,
        catalogData: payload.catalogData,
        error: null,
      };

    case SET_CATALOG_LOADING:
      return {
        ...state,
        isLoading: payload.isLoading,
      };

    case SET_CATALOG_ERROR:
      return {
        ...state,
        error: payload.error,
      };

    case CLEAR_CATALOGS:
      return initialState;
  }
}

export default catalogsReducer;
